<template>
  <v-autocomplete
    v-model="selectedItems"
    :items="data"
    :item-value="itemValue"
    :item-text="itemText"
    :multiple="multiple"
    :small-chips="multiple"
    :single-line="!multiple"
    :rules="rules"
    :error-messages="errorMessages"
    :required="required"
    :hint="hint"
    :label="label"
    :disabled="disabled"
    :value="value">
    <template v-if="multiple" v-slot:prepend-item>
      <v-list-item v-if="selAll"
                   @click="toggle">
        <v-list-item-content>
          <v-list-item-title>{{ text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-if="selAll" class="mt-2" />
    </template>

    <template v-if="multiple" v-slot:selection="{ item, index }">
      <v-chip v-if="maxElements!==0 && index < maxElements" small>
        <span>{{ item.name }}</span>
      </v-chip>
      <span v-if="maxElements===0 && index===0">Выбрать поля для отображения</span>
      <span
        v-if="index === maxElements && maxElements!==0 && index!==0"
        class="grey--text caption">(+{{ selectedItems.length - maxElements }} others)</span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "BaseAutoComplete",
  props: {
    items: {
      type: [Array, Object],
      default: () => []
    },
    hint: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    selAll: {
      type: Boolean,
      default: true
    },
    maxElements: {
       type: Number,
      default: 4
    },
    rules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: String,
      default: ''
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    itemText: {
      type: String,
      default: 'name'
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, Object, Number, String]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedItems: this.value,
      data: this.items,
      text: 'Выбрать все'
    }
  },
  computed: {
      selectAll () {
        return  this.selectedItems ? this.selectedItems.length === this.data.length : false
      }
  },
  watch: {
    selectedItems (newValue, oldValue) {
      this.$emit('updateSelected', newValue)
    },
    items (newValue) {
      this.data = newValue
    },
    value (newValue) {
      this.selectedItems = newValue
    }
  },
  methods: {
      toggle () {
        this.$nextTick(() => {
          if (this.selectAll) {
            this.selectedItems = []
            this.text = 'Выбрать все'
          } else {
            this.selectedItems = this.data.slice().map(val => val.id ? val.id : val.name)
            this.text = 'Отменить выбор'
          }
        })
      }
    }

}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/base/BaseAutoComplete.vue